import React from "react";
import styles from "./heroSection.module.css";

function homeHeroSection({ title, subtitle, heroImage, p1, p2, p3 }) {
  return (
    <>
      <div id="AboutUs" className={styles.headingWrapper}>
        <h2 className="mainHeading">{title}</h2>
        <p className="subHeading">{subtitle}</p>
      </div>
      <div className={styles.homeHeroWrapper}>
        <img src={`${heroImage}`} alt="Fruits" />
        <p className={styles.homeHeroParagraph}>{p1}</p>
      </div>
    </>
  );
}

export default homeHeroSection;
